import React from 'react'
import './SortInfo.css'

export default function InsertionSort() {
  return (
    <div>
      <div className='sort-info'>
      <div className="sort-name">
          Name : Insertion Sort
        </div>
        <div className="sort-time">
          Time Complexity : O(n<sup>2</sup>)
        </div>
    </div>
    </div>
  )
}
